'use strict';
(function () {
  angular.module('pentaApp').factory('group.resource', service);

  service.$inject = ['$resource'];
  function service($resource) {
    return $resource('/progressiveApp/api/group');
  }
})();
